export default __webpack_public_path__ + "static/media/twitter.ea27c51e.svg";